import type { SaveStatus } from '../state/projectSession';
import { Button } from './ui';

const LABELS: Record<SaveStatus, string> = {
  loading: 'Loading…',
  saved: 'All changes saved',
  unsaved: 'Unsaved changes',
  saving: 'Saving…',
  error: 'Save failed',
};

const DOT: Record<SaveStatus, string> = {
  loading: 'bg-zinc-500',
  saved: 'bg-emerald-500',
  unsaved: 'bg-amber-400',
  saving: 'bg-sky-400 animate-pulse',
  error: 'bg-red-500',
};

export function SaveIndicator({ status, error, onSave }: { status: SaveStatus; error?: string; onSave: () => void }) {
  return (
    <div className="flex items-center gap-2">
      <p role="status" aria-live="polite" data-testid="save-status" data-status={status} className="flex items-center gap-2 text-xs text-zinc-300">
        <span aria-hidden="true" className={`inline-block size-2 rounded-full ${DOT[status]}`} />
        <span>{LABELS[status]}</span>
        {status === 'error' && error && <span className="sr-only">: {error}</span>}
      </p>
      <Button
        size="sm"
        variant={status === 'error' ? 'danger' : 'secondary'}
        onClick={onSave}
        disabled={status === 'saving' || status === 'loading'}
        title="Save now (Ctrl+S)"
      >
        {status === 'error' ? 'Retry save' : 'Save'}
      </Button>
    </div>
  );
}
